import { useEffect, useState } from "react";
import { useOrderCrud } from "../../../../context/OrderCrudContext";
import update from 'immutability-helper';
import useProducts from "../../../../hooks/useProducts";
// NOTA: Ya no importamos useAxios aquí porque la imagen la maneja el filtro
import TemplatesModal from "./TemplatesModal";
import ManualOrderForm from "../../Orders/ManualOrderForm";
import OrdersCreateFiltersForm from "../../Orders/OrdersCreateFiltersForm";
import ProductCard from "../../../ProductCard";
import { FaPlus, FaShoppingBag } from "react-icons/fa";
import DetailProductModal from "../../../DetailProductModal";
import ServiceSelect from "../../../ServiceSelect";
import OrderTypeSelector from "../../../OrderTypeSelector";
import OrderSidebar from "../../../OrderSidebar";
import Pagination from "../../../Pagination";
import useAxios from "../../../../hooks/useAxios";
import ManualItemForm from "../../../ManualItemForm";

const StepFour = () => {

    const [showOrder, setShowOrder] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [detailProduct, setDetailProduct] = useState(null);

    const [filters, setFilters] = useState({
        serviceId: '',
        name: '',
        reference: '',
        providerName: '',
        code: '',
        page: 1,
        subCategoryId: '',
        orderBy: 'name,ASC',
        categoryId: '',
        with: ['children'],
        parentsOnly: 'true',
        perPage: 18
    });

    const { data, setData } = useOrderCrud();

    const [{ data: products, loading: loadingProducts }, getProducts] = useAxios({ url: `/products/for-orders`, params: filters }, { useCache: false });

    useEffect(() => {
        const bodies = document.getElementsByTagName('body');
        if (showOrder) {
            for (let index = 0; index < bodies.length; index++) {
                const element = bodies[index];
                element.style.overflow = 'hidden';
            }
        } else {
            for (let index = 0; index < bodies.length; index++) {
                const element = bodies[index];
                element.style.overflow = 'auto';
            }
        }
    }, [showOrder])

    useEffect(() => {
        setFilters((oldFilters) => {
            return {
                ...oldFilters,
                serviceId: data?.service?.id || '',
                page: 1
            }
        });
    }, [data?.service])

    const handleRemove = (index) => {
        data?.orderItems?.splice(index, 1);
        setData((oldData) => {
            return {
                ...oldData,
                orderItems: data?.orderItems
            }
        });
    }

    const handleArrayChange = (e, index, arrayName) => {
        const newArrayValues = update(data?.[arrayName], { [index]: { [e.target.name]: { $set: e.target.value } } });
        setData((oldData) => {
            return {
                ...oldData,
                [arrayName]: newArrayValues
            }
        });
    }

    const handleToggleVersion = (productVersion) => {
        console.log(productVersion);
        const res = orderHasProduct(productVersion?.id);
        if (res?.have) {
            data?.orderItems?.splice(res?.index, 1);
            setData((oldData) => {
                return {
                    ...oldData,
                    orderItems: data?.orderItems
                }
            });
        } else {
            setData((oldData) => {
                return {
                    ...oldData,
                    orderItems: [
                        ...oldData?.orderItems,
                        {
                            name: `${productVersion?.name}`,
                            quantity: 1,
                            price: productVersion?.price,
                            code: productVersion?.code,
                            productId: productVersion?.id
                        }
                    ]
                }
            });
        }
    }

    const orderHasProduct = (id) => {
        const itemIndex = data?.orderItems?.findIndex(x => x.productId === id);
        console.log(itemIndex);
        if (itemIndex >= 0) return { have: true, index: itemIndex };
        return false;
    }

    const handleTemplate = (template) => {
        setData((oldData) => {
            return {
                ...oldData,
                orderItems: template?.items?.map((item) => {
                    return {
                        id: item?.id,
                        quantity: item?.quantity,
                        name: item?.name,
                        price: item?.price,
                        code: item?.code
                    }
                })
            }
        });
        setShowModal(false);
    }

    const handlePage = (page) => {
        setFilters((old) => ({ ...old, page }));
    }

    return (
        <div>
            {
                !data?.service ?
                    <ServiceSelect />
                    :
                    <>
                        <div className="container-fluid mb-5 animate__animated animate__zoomIn" style={{ paddingTop: 0 }}>
                            <div className="row">
                                <OrderTypeSelector />

                                <OrdersCreateFiltersForm
                                    filters={filters}
                                    setFilters={setFilters}
                                />

                                <div className="col-12 mb-5">
                                    <h1 className="text-center">
                                        Productos
                                    </h1>
                                    <div className="row align-items-center position-relative">
                                        {
                                            products?.data?.length > 0 ?
                                                products?.data?.map((product, i) => {
                                                    console.log(product);
                                                    var indexInOrder = orderHasProduct(Number(product?.id));
                                                    console.log(indexInOrder);
                                                    return (
                                                        <ProductCard
                                                            onChange={(e, i) => handleArrayChange(e, i, 'orderItems')}
                                                            key={product?.id}
                                                            setDetailProduct={setDetailProduct}
                                                            product={product}
                                                            indexInOrder={indexInOrder?.index}
                                                            onRemove={() => indexInOrder?.have ? handleRemove(indexInOrder?.index) : null}
                                                            orderHasProduct={indexInOrder?.have}
                                                            handleToggleVersion={handleToggleVersion}
                                                        />
                                                    )
                                                })
                                                :
                                                !loadingProducts &&
                                                <div className="text-center mt-3 h4">
                                                    No se encontrarón productos.
                                                </div>
                                        }
                                        {
                                            loadingProducts &&
                                            <div className="text-center position-absolute d-flex align-items-center justify-content-center top-0 left-0 w-100 h-100 border border-primary" style={{ background: 'rgba(255,255,255, .4)' }}>
                                                <div class="spinner-border text-primary" role="status" style={{ width: 80, height: 80 }}>
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <Pagination
                                        onBack={handlePage}
                                        onNext={handlePage}
                                        currentPage={filters?.page}
                                        numberOfPages={products?.last_page}
                                        onClickPage={handlePage}
                                    />
                                </div>
                            </div>
                        </div>
                        <DetailProductModal
                            detailProduct={detailProduct}
                            setDetailProduct={setDetailProduct}
                            handleToggleVersion={handleToggleVersion}
                            orderHasProduct={orderHasProduct}
                        />

                        <TemplatesModal
                            isReplacement={data?.isReplacement}
                            show={showModal}
                            onClose={() => setShowModal(false)}
                            onSelectTemplate={handleTemplate}
                        />
                    </>
            }

            <OrderSidebar
                show={showOrder}
                setShow={setShowOrder}
            />

            <ManualItemForm
                data={data}
                setData={setData}
            />

            <button
                onClick={() => setShowOrder(true)}
                className="align-items-center btn btn-primary"
                style={{ display: data?.service ? 'flex' : 'none', position: 'fixed', right: 30, bottom: 20, width: 'fit-content' }}
            >
                <div>
                    Ver pedido
                </div>
                <div className="position-relative">
                    <FaShoppingBag style={{ marginLeft: 10, fontSize: 34 }} />
                    <span
                        className="position-absolute text-center fw-bold"
                        style={{ top: 15, left: 12, width: 30, color: '#1362FC' }}
                    >
                        {data?.orderItems?.length < 100 ? data?.orderItems?.length : "+99"}
                    </span>
                </div>
            </button>

        </div>
    )
}

export default StepFour;